'use client'

import * as DialogPrimitive from '@radix-ui/react-dialog'
import { type ComponentProps } from 'react'

import { cn } from '@/shared/lib'

export const Root = ({
  ...props
}: ComponentProps<typeof DialogPrimitive.Root>) => {
  return <DialogPrimitive.Root data-slot="screen-overlay" {...props} />
}

export const Trigger = ({
  ...props
}: ComponentProps<typeof DialogPrimitive.Trigger>) => {
  return (
    <DialogPrimitive.Trigger data-slot="screen-overlay-trigger" {...props} />
  )
}

export const Portal = ({
  ...props
}: ComponentProps<typeof DialogPrimitive.Portal>) => {
  return <DialogPrimitive.Portal data-slot="screen-overlay-portal" {...props} />
}

export const Close = ({
  ...props
}: ComponentProps<typeof DialogPrimitive.Close>) => {
  return <DialogPrimitive.Close data-slot="screen-overlay-close" {...props} />
}

export const Overlay = ({
  className,
  ...props
}: ComponentProps<typeof DialogPrimitive.Overlay>) => {
  return (
    <DialogPrimitive.Overlay
      data-slot="dialog-overlay"
      className={cn(
        'z-dialog fixed inset-0',
        'data-[state=open]:animate-in data-[state=open]:fade-in-0',
        'data-[state=closed]:animate-out data-[state=closed]:fade-out-0',
        className,
      )}
      {...props}
    />
  )
}

export const Content = ({
  className,
  children,
  ...props
}: ComponentProps<typeof DialogPrimitive.Content>) => {
  return (
    <Portal>
      <Overlay />
      <DialogPrimitive.Content
        data-slot="screen-overlay-content"
        className={cn('z-dialog fixed inset-0 bg-white', className)}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </Portal>
  )
}

export const Title = ({
  className,
  ...props
}: ComponentProps<typeof DialogPrimitive.Title>) => {
  return (
    <DialogPrimitive.Title
      data-slot="screen-overlay-title"
      className={cn('typo-headline2 font-semibold text-black', className)}
      {...props}
    />
  )
}

export const Description = ({
  className,
  ...props
}: ComponentProps<typeof DialogPrimitive.Description>) => {
  return (
    <DialogPrimitive.Description
      data-slot="screen-overlay-description"
      className={cn('typo-body1 text-black', className)}
      {...props}
    />
  )
}
